import React from 'react'
import RaisedButton from 'material-ui/RaisedButton';
import TextField from '@material-ui/core/TextField'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import FormHelperText from '@material-ui/core/FormHelperText'
import DatePicker from 'material-ui/DatePicker';
import Snackbar from '@material-ui/core/Snackbar';
import moment from 'moment'
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Button from '@material-ui/core/Button';
import { validateGSTN } from '../utils/VendorApiUtils'
const errorText = 'This field is required'
const errorText2 = 'Please enter GST number'
class VendorGstDetails extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      data: {
        gstn: '',
        gstn_verified: '',
        gstn_verification_remarks: '',
        gstn_status: '',
        legal_name: '',
        entity_type: '',
        registration_type: '',
        department_code: '',
        nature_of_business: '',
        registration_date: null,
      },
      gst_verifications: ['YES', 'NO'],
      gst_status_options: ['ACTIVE', 'CANCELLED', 'SUSPENDED', 'NOT APPLICABLE'],
      disable_gst_fields: false,
      gstn_verification_remarksErr: false,
      gstn_verification_remarksErrText: '',
      gstnErrText: '',
      gstn_verifiedErrText: '',
      gstn_statusErr: false,
      gstn_statusErrText: '',
      legal_nameErrText: '',
      entity_typeErrText: '',
      registration_typeErrText: '',
      department_codeErrText: '',
      nature_of_businessErrText: '',
      registration_dateErrText: '',
      gstnErr: false,
      gstn_verifiedErr: false,
      legal_nameErr: false,
      entity_typeErr: false,
      registration_typeErr: false,
      department_codeErr: false,
      nature_of_businessErr: false,
      registration_dateErr: false,
      snackText: '',
      snackOpen: false,
      vendorExistsDialogBox: false,
      vendorExistsDialogBoxText: '',
    }
  }
  componentDidMount() {
    if (this.props.data.vendorGstDetails) {
      this.setState({ data: this.props.data.vendorGstDetails, status: this.props.data.status, disable_gst_fields: this.props.data.vendorGstDetails.gstn_status === 'NOT APPLICABLE'})
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.data.vendorGstDetails) {
      this.setState({ data: nextProps.data.vendorGstDetails, status: nextProps.data.status,  disable_gst_fields: nextProps.data.vendorGstDetails.gstn_status === 'NOT APPLICABLE' })
    }
  }
  handleChange = (props) => (event, index, value) => {
    if (props === 'gstn') {
      let myRegxp = /^([a-zA-Z0-9]){0,15}$/
      if (!myRegxp.test(event.target.value)) {
        this.setState({ snackText: "Invalid GST Number", snackOpen: true })
      }
      else
        this.setState({ data: { ...this.state.data, [props]: event.target.value.toUpperCase() }, [props + 'ErrText']: '', [props + 'Err']: false })
    }
    else if (props === 'gstn_status') {
      if (event.target.value === "NOT APPLICABLE") {
        this.setState({
          data: {
            ...this.state.data,
            [props]: event.target.value,
            gstn: '',
            gstn_verified: '',
            gstn_verification_remarks: '',
            legal_name: '',
            entity_type: '',
            registration_type: '',
            department_code: '',
            nature_of_business: '',
            registration_date: null,
          },
          disable_gst_fields: true,
          gstn_statusErr: false, gstn_statusErrText: '' 
        })
      } else {
        this.setState({
          data: {
            ...this.state.data,
            [props]: event.target.value
          },
          disable_gst_fields: false,
          gstn_statusErr: false, gstn_statusErrText: ''
        })
      }
    }
    else if (props === 'gstn_verified') {
      this.setState({
        data: {
          ...this.state.data, gstn_verified: event.target.value, gstn_verification_remarks: '', legal_name: '',
          entity_type: '', registration_type: '', department_code: '', nature_of_business: '', registration_date: null
        }, [props + 'ErrText']: '', [props + 'Err']: false,
        gstn_verification_remarksErr: false, gstn_verification_remarksErrText: '',
        legal_nameErr: false, legal_nameErrText: '', entity_typeErr: false, entity_typeErrText: '', registration_typeErr: false,
        registration_typeErrText: '', department_codeErr: false, department_codeErrText: '', nature_of_businessErr: false,
        nature_of_businessErrText: '', registration_dateErr: false, registration_dateErrText: ''
      })
    } else if (props === 'registration_date') {
      this.setState({ data: { ...this.state.data, [props]: index }, [props + 'ErrText']: '', [props + 'Err']: false })
    }
    else {
      this.setState({ data: { ...this.state.data, [props]: event.target.value }, [props + 'ErrText']: '', [props + 'Err']: false })
    }
  }
  handleNext = () => {
    // if (this.state.data.gstn === '') {
    //   this.setState({ gstnErrText: errorText, gstnErr: true })
    // }
    // if (this.state.data.gstn_verified === '') {
    //   this.setState({ gstn_verifiedErrText: errorText, gstn_verifiedErr: true })
    // }
    // if (this.state.data.gstn_verified !== 'yes') {
    //   if (this.state.data.gstn_verification_remarks === '') {
    //     this.setState({ gstn_verification_remarksErr: true, gstn_verification_remarksErrText: errorText })
    //   }
    // }
    // else {

    //   if (this.state.data.legal_name === '') {
    //     this.setState({ legal_nameErrText: errorText, legal_nameErr: true })
    //   }
    //   if (this.state.data.entity_type === '') {
    //     this.setState({ entity_typeErr: true, entity_typeErrText: errorText })
    //   }
    //   if (this.state.data.registration_type === '') {
    //     this.setState({ registration_typeErrText: errorText, registration_typeErr: true })
    //   }
    //   if (this.state.data.department_code === '') {
    //     this.setState({ department_codeErrText: errorText, department_codeErr: true })
    //   }
    //   if (this.state.data.nature_of_business === '') {
    //     this.setState({ nature_of_businessErr: true, nature_of_businessErrText: errorText })
    //   }
    //   if (this.state.data.registration_date === null) {
    //     this.setState({ registration_dateErrText: errorText, registration_dateErr: true })
    //   }
    // }

    
    if (this.state.data.gstn !== '') {
      let myRegxp = /^([a-zA-Z0-9_-]){15}$/;
      if (!myRegxp.test(this.state.data.gstn)) {
        this.setState({ snackText: "GST number length should be 15 characters", snackOpen: true })
        return
      }
    }
    if (this.state.data.gstn === '' && this.state.data.gstn_verified === 'yes') {
      this.setState({ gstnErrText: 'Please specify GST number ', gstnErr: true })
      return;
    }
    if (this.state.data.gstn !== '' && this.state.data.gstn_verified === '') {
      this.setState({ gstn_verifiedErrText: errorText, gstn_verifiedErr: true })
      return;
    }
    if (this.state.data.gstn_verified === 'no') {
      if (this.state.data.gstn_verification_remarks === '') {
        this.setState({ gstn_verification_remarksErr: true, gstn_verification_remarksErrText: errorText })
        return;
      }
    } 
    if ((this.state.data.legal_name=== null || this.state.data.legal_name === '') && this.state.data.gstn_verified === 'yes') {
      this.setState({ legal_nameErrText: errorText, legal_nameErr: true });
      return;
    }
    if ((this.state.data.entity_type === null || this.state.data.entity_type === '') && this.state.data.gstn_verified === 'yes') {
      this.setState({ entity_typeErr: true, entity_typeErrText: errorText });
      return;
    }

    if (this.state.data.gstn_status === '') {
      this.setState({ gstn_statusErrText: 'Please select GST status', gstn_statusErr: true })
    } else if (this.state.data.gstn_status !== 'NOT APPLICABLE' && (this.state.data.gstn_verified === '' || this.state.data.gstn === '')) { 
      if (this.state.data.gstn_verified === '') {
        this.setState({ gstn_verifiedErrText: errorText, gstn_verifiedErr: true })
      }
      if (this.state.data.gstn === '') {
        this.setState({ gstnErrText: errorText, gstnErr: true })
      }
    } else {
      if (this.state.data.gstn_verified !== '') {
        this.setState({ gstn_verifiedErrText: '', gstn_verifiedErr: false })
      }
      if (this.state.data.gstn !== '') {
        this.setState({ gstnErrText: '', gstnErr: false })
      }
      this.moveToNext();    
    }
  }

  moveToNext = () => {
    this.state.status !== 'edit' ? validateGSTN(this.state.data.gstn)
        .then(response => {
          if (response) {
            if (response.status === 'success') {
              this.props.handleNext(this.state.data)
            }
            else if(response.status === 'duplicate'){
              this.setState({ vendorExistsDialogBoxText: response.message, vendorExistsDialogBox: true })
            }
            else {
              this.setState({ snackText: response.message, snackOpen: true })
            }
          }
        }) : this.props.handleNext(this.state.data)
  }

  handleClick = (props) => (event, index, value) => {
    if (props !== 'gstn' && this.state.data.gstn !== '') {
      if (this.state.data.gstn.length < 15)
        this.setState({ gstnErrText: 'Invalid number (length should be 15 characters) ', gstnErr: true })
    }
  }
  handleCloseSnack() {
    this.setState({ snackOpen: false })
  }
  handleClear() {
    this.setState({
      data: {
        gstn: '',
        gstn_verified: '',
        gstn_status: '',
        gstn_verification_remarks: '',
        legal_name: '',
        entity_type: '',
        registration_type: '',
        department_code: '',
        nature_of_business: '',
        registration_date: null,
      }
    })
  }
  handleCloseVendorExistsDialogBox(){
    this.setState({vendorExistsDialogBox: false, vendorExistsDialogBoxText:''})
  }
  render() {
    return (
      <div style={{ marginTop: '30px' }}>
        <span>If you want to enter this details please
                            <a style={{ paddingLeft: '5px' }} href='https://www.knowyourgst.com/gst-number-search/' target="_blank" rel="noopener noreferrer">Click here</a> and enter your GST number</span>
        <div>
          <TextField
            label="GST Number"
            placeholder="Enter GST Number"
            value={this.state.data.gstn}
            onChange={this.handleChange('gstn')}
            onClick={this.handleClick('gstn')}
            style={{ width: '250px', marginRight: '278px', marginTop: '40px', cursor: this.disable_gst_fields ? 'not-allowed' : 'text' }}
            helperText={this.state.gstnErrText}
            error={this.state.gstnErr}
            margin='normal'
            disabled={this.state.disable_gst_fields}
          /><br />
          <div style={{ display: 'flex' }}>
            <FormControl margin='normal'>
              <InputLabel htmlFor="gst-status">*GST Status</InputLabel>
              <Select
                value={this.state.data.gstn_status}
                onChange={this.handleChange('gstn_status')}
                inputProps={{
                  name: 'Gst Status',
                  id: 'gst-status',
                }}
                style={{ width: '250px', textAlign: 'left' }}
                helperText={this.state.gstn_statusErrText}
                error={this.state.gstn_statusErr}
              >
                {
                  this.state.gst_status_options.map(gstn_status => {
                    return <MenuItem value={gstn_status}>{gstn_status}</MenuItem>
                  })
                }
              </Select>
              <FormHelperText style={{ color: 'red', minHeight: '0px' }}>{this.state.gstn_statusErrText}</FormHelperText>
            </FormControl>
          </div>
          <div style={{ display: 'flex' }}>
            <FormControl margin='normal'>
              <InputLabel htmlFor="gst-number">*GST Number Verified</InputLabel>
              <Select
                value={this.state.data.gstn_verified}
                onChange={this.handleChange('gstn_verified')}
                onClick={this.handleClick('gstn_verified')}
                inputProps={{
                  name: 'Gst Number',
                  id: 'gst-number',
                }}
                style={{ width: '250px', textAlign: 'left', cursor: this.disable_gst_fields ? 'not-allowed' : 'pointer' }}
                helperText={this.state.gstn_verifiedErrText}
                error={this.state.gstn_verifiedErr}
                disabled={this.state.disable_gst_fields}
              >
                {
                  this.state.gst_verifications.map(gstn_verified => {
                    return <MenuItem value={gstn_verified.toLowerCase()}>{gstn_verified}</MenuItem>
                  })
                }
              </Select>
              <FormHelperText style={{ color: 'red', minHeight: '0px' }}>{this.state.gstn_verifiedErrText}</FormHelperText>
            </FormControl>
            {this.state.data.gstn_verified !== 'yes' &&

              <TextField
                label="*Please specify"
                placeholder="Enter Reason"
                value={this.state.data.gstn_verification_remarks}
                onChange={this.handleChange('gstn_verification_remarks')}
                onClick={this.handleClick('gstn_verification_remarks')}
                style={{ width: '250px', marginLeft: '12px', cursor: this.disable_gst_fields ? 'not-allowed' : 'pointer'}}
                margin='normal'
                helperText={this.state.gstn_verification_remarksErrText}
                error={this.state.gstn_verification_remarksErr}
                disabled={this.state.disable_gst_fields}
              />} </div>
          {
            (this.state.data.gstn_verified==='yes')?
          <TextField
            label="*Legal Name"
            placeholder="Enter Legal Name"
            value={this.state.data.legal_name}
            onChange={this.handleChange('legal_name')}
            margin='normal'
            multiline
            helperText={this.state.legal_nameErrText}
            error={this.state.legal_nameErr}
            style={{ width: '520px' }} />
            :null}
            {(this.state.data.gstn_verified==='yes')?<br/>:null}
            {(this.state.data.gstn_verified==='yes')?
          <TextField
            label="*Entity Type"
            placeholder="Enter Entity Type"
            value={this.state.data.entity_type}
            onChange={this.handleChange('entity_type')}
            margin='normal'
            multiline
            helperText={this.state.entity_typeErrText}
            error={this.state.entity_typeErr}
            disabled={(this.state.data.gstn_verified==='no')?true:false}
            style={{ width: '250px' }} />
            :null}
            {(this.state.data.gstn_verified==='yes')?<br/>:null}
            {(this.state.data.gstn_verified==='yes')?
          <TextField
            label="Registration Type"
            placeholder="Enter Registration Type"
            value={this.state.data.registration_type}
            disabled={(this.state.data.gstn_verified==='no')?true:false}
            onChange={this.handleChange('registration_type')}
            margin='normal'
            multiline
            helperText={this.state.registration_typeErrText}
            error={this.state.registration_typeErr}
            style={{ width: '250px' }} />
            :null}
            {(this.state.data.gstn_verified==='yes')?<br/>:null}
            {(this.state.data.gstn_verified==='yes')?
          <TextField
            label="Department Code"
            placeholder="Enter Department Code"
            value={this.state.data.department_code}
            onChange={this.handleChange('department_code')}
            margin='normal'
            multiline
            helperText={this.state.department_codeErrText}
            error={this.state.department_codeErr}
            disabled={(this.state.data.gstn_verified==='no')?true:false}
            style={{ width: '250px' }} />
            :null}
            {(this.state.data.gstn_verified==='yes')?<br/>:null}
            {(this.state.data.gstn_verified==='yes')?
          <TextField
            label="Nature of Business"
            placeholder="Enter Nature of Business"
            value={this.state.data.nature_of_business}
            onChange={this.handleChange('nature_of_business')}
            margin='normal'
            multiline
            helperText={this.state.nature_of_businessErrText}
            error={this.state.nature_of_businessErr}
            disabled={(this.state.data.gstn_verified==='no')?true:false}
            style={{ width: '250px' }} />
            :null}
            {(this.state.data.gstn_verified==='yes')?<br/>:null}
            {(this.state.data.gstn_verified==='yes')?
          <DatePicker
            floatingLabelText='Registration Date'
            hintText='Registration Date'
            value={this.state.data.registration_date ? moment(this.state.data.registration_date).toDate() : ''}
            onChange={this.handleChange('registration_date')}
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{ max: moment(new Date()).format('YYYY-MM-DD') }}
            floatingLabelStyle={{ color: 'rgba(0, 0, 0, 0.54)' }}
            underlineStyle={{ borderBottomColor: 'rgba(0, 0, 0, 0.42)' }}
            maxDate={new Date()}
            margin='normal'
            style={{ width: '250px' }}
            disabled={(this.state.data.gstn_verified==='no')?true:false}
            helperText={this.state.registration_dateErrText}
            error={this.state.registration_dateErr}
          />:null}
          <br />
        </div>
        <div className="zaps-form-actions">
          <RaisedButton
            label="Clear"
            primary={true}
            onClick={this.handleClear.bind(this)}
            buttonStyle={{ backgroundColor: 'red' }}
          />
          <RaisedButton
            label="Back"
            primary={true}
            onClick={this.props.handleBack.bind(this, this.state.data)}
            style={{ marginLeft: '20px' }}
          />

          <RaisedButton style={{ marginLeft: '20px' }} label={`Next`} primary={true} onClick={this.handleNext.bind(this)} />
        </div>
        <Dialog
          open={this.state.vendorExistsDialogBox}
          onClose={this.handleCloseVendorExistsDialogBox.bind(this)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {this.state.vendorExistsDialogBoxText}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleCloseVendorExistsDialogBox.bind(this)} color="primary" autoFocus>
              OK
            </Button>
          </DialogActions>
        </Dialog>
        <Snackbar
          open={this.state.snackOpen}
          autoHideDuration={1000}
          onClose={this.handleCloseSnack.bind(this)}
          message={this.state.snackText}
        />
      </div>
    )
  }
}
export default VendorGstDetails


// WEBPACK FOOTER //
// ./src/components/VendorGstDetails.js